import { robotoRegular, scarpaGray200, scarpaGray50, scarpaGray500, scarpaGray800, spanishViridian500 } from '@habitech/shared';
import styled, { css } from 'styled-components';

interface INotesContainerProps {
    noteError: boolean;
}
const ScrollCSS = css`
    &::-webkit-scrollbar {
        background: rgba(52, 131, 250, 0.2);
        width: 8px;
    }

    &::-webkit-scrollbar-thumb {
        border: 1px solid ${scarpaGray200};
        background: ${scarpaGray200};
        border-radius: 4px;
    }
`;

const errorCSS = css`
    border: 1.5px solid #ff0000;
    color: #ff0000;
`;

export const NotesContainer = styled.div<INotesContainerProps>`
    width: 100%;
    .note-textarea {
        background: white;
        border: 1px solid ${scarpaGray500};
        border-radius: 6px;
        font-family: ${({ theme }) => theme.fonts};
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        resize: none;
        color: ${scarpaGray800};
        width: 100%;
        box-sizing: border-box;
        padding: 16px;
        height: auto;
        &::placeholder {
            opacity: 0.7;
            line-height: 18.75px;
        }
        &:focus-visible {
            border: 1.5px solid ${spanishViridian500};
            outline: none;
        }
        ${ScrollCSS}
        ${({ noteError }) => noteError && errorCSS}
        @media ${({ theme }) => theme.screenSizes.tablet} {
            height: 305px;
        }
        @media ${({ theme }) => theme.screenSizes.laptop} {
            height: 105px;
        }
    }
    .container-info-notes {
        display: flex;
        justify-content: space-between;
        align-items: center;

        small {
            font-size: 12px;
            font-family: ${robotoRegular};
            color: #949494;
            text-align: right;

            &.counter {
                color: ${({ noteError }) => (noteError ? '#FF0000' : '#949494')};
            }
        }
    }

    .container-buttons-notes {
        margin-top: 8px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 8px;

        .btn-see-notes {
            flex: 1;
            position: relative;
            border-radius: 100px;
            background-color: ${scarpaGray50};
            height: 32px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            padding: 8px 12px;
            box-sizing: border-box;
            gap: 6px;
            text-align: center;
            font-size: 14px;
            color: ${scarpaGray500};
            font-family: ${robotoRegular};
            border: none;
            max-width: 133px;
        }
    }

    .error-note {
        color: #ff0000;
        font-size: 10px;
        font-family: ${robotoRegular};
        margin-top: 2px;
        ${({ noteError }) => !noteError && 'display: none;'}
    }

    .note-by {
        font-size: 12px;
        font-family: ${robotoRegular};
        color: #949494;
        margin-bottom: 5px;
    }
`;
